import React from 'react';
const BuildingIcon = ({ size=20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 21V3h14v18" />
    <path d="M7 7h2" />
    <path d="M11 7h2" />
    <path d="M7 11h2" />
    <path d="M11 11h2" />
    <path d="M7 15h2" />
    <path d="M11 15h2" />
    <path d="M17 9h4v12h-4" />
  </svg>
);
export default BuildingIcon;